module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "container"
  }, [_h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Barchart"]), " ", _h('bar-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Barchart with reactive mixing for live data"]), " ", _h('reactive-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Linechart"]), " ", _h('line-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Doughnutchart"]), " ", _h('doughnut-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Piechart"]), " ", _h('pie-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Radarchart"]), " ", _h('radar-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Polararea"]), " ", _h('polar-area-example'), " ", _h('h1', {
    staticStyle: {
      "text-align": "center",
      "margin": "40px 0"
    }
  }, ["Bubblechart"]), " ", _h('bubble-example')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b02f39e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/App.vue
// module id = 402
// module chunks = 0